import {
  AfterViewInit,
  ChangeDetectorRef,
  Component, ElementRef, HostListener,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {takeUntilDestroy} from "take-until-destroy";
import {LogManager} from "../../log/log.manager";
import {LogCat} from "../../log/log.categories";
import {ChangePasswordService} from "../services/change.password.service";
import {ChangePasswordResult, IChangePasswordRequest} from "../types";
import {SetPasswordComponent} from "../../components/set.password/set.password.component";
import {WindowRef} from "@progress/kendo-angular-dialog";

@Component({
  selector: 'app-change-password',
  templateUrl: './change.password.component.html',
  styleUrls: ['./change.password.component.scss']
})
export class ChangePasswordComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild("PasswordForm", {static: false}) public passwordForm: SetPasswordComponent;
  @ViewChild("OldPassword", {static: false}) public oldPasswordCrl: ElementRef;

  public formControls: FormGroup;
  public userName = '';
  public oldPasswordInCorrect: boolean;
  public success: boolean;
  public error: boolean;
  public errorText: string;
  public inProgress = false;
  public passwordVisible = false;
  public formHeight: number;
  public informationText = undefined;
  public invalidCharacters = false;

  constructor(private changePasswordService: ChangePasswordService,
              private changeDetector: ChangeDetectorRef,
              public window: WindowRef) {
  }

  ngOnInit() {
    this.formControls = new FormGroup({
      userName: new FormControl('', {validators: [Validators.required]}),
      oldPassword: new FormControl('', {validators: [Validators.required]})
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.formControls.addControl("newPassword", this.passwordForm.formControls);
      this.oldPasswordCrl.nativeElement.focus();
      this.changeDetector.markForCheck();
    });
  }

  ngOnDestroy() {
  }

  public changePassword() {
    if (this.isValid()) {
      this.inProgress = true;
      this.error = false;
      const userCredentials: IChangePasswordRequest = {
        userName: this.userName,
        oldPassword: btoa(this.formControls.controls['oldPassword'].value),
        newPassword: btoa(this.passwordForm.formControls.controls['password'].value)
      };
      const passwordForm = this.passwordForm;
      this.changePasswordService.changePassword(userCredentials)
        .pipe(takeUntilDestroy(this))
        .subscribe(res => {
            if (res.result === ChangePasswordResult.PasswordChangedSuccessfully) {
              this.error = false;
              this.success = true;
            } else if (res.result === ChangePasswordResult.OldPasswordInCorrect) {
                this.error = false;
                this.oldPasswordInCorrect = true;
            } else if (res.result === ChangePasswordResult.NewPasswordRecentlyUsed) {
                this.error = false;
                passwordForm.setPasswordRecentlyUsed();
            } else if (res.result === ChangePasswordResult.PasswordIsInvalid) {
              this.error = true;
              this.errorText = 'PasswordInvalid';
              this.informationText = 'PleaseRefreshThePageInBrowser';
            }
            this.inProgress = false;
            this.changeDetector.markForCheck();
          },
          err => {
            this.error = true;
            this.errorText = 'ErrorDuringPasswordChange';
            this.informationText = undefined;
            this.inProgress = false;
            LogManager.error(LogCat.Login.ForgotPassword, err);
            this.changeDetector.markForCheck();
          });
    }
    this.changeDetector.markForCheck();
  }

  public togglePasswordVisibility() {
    this.passwordVisible = !this.passwordVisible;
  }

  public backFromError() {
    this.error = false;
    this.changeDetector.markForCheck();
  }

  public resetErrors() {
    this.oldPasswordInCorrect = false;
    this.changeDetector.markForCheck();
  }

  private isValid(): boolean {
    if (this.formControls.controls['oldPassword'].invalid) {
      return false;
    }
    this.invalidCharacters = false;
    try {
      const passwordEnc = btoa(this.formControls.controls['oldPassword'].value);
    } catch (e) {
      this.invalidCharacters = true;
      return false;
    }
    return this.passwordForm.isValid();
  }

  @HostListener("window:beforeunload", ['$event'])
  onBeforeUnload($event: BeforeUnloadEvent) {
    $event.returnValue = "True";
  }
}
